// Keep this complete-string decimal grammar in sync with backend/material_integrity.py.
const DECIMAL_LIMIT = /^[+-]?(?:[0-9]+(?:\.[0-9]+)?|\.[0-9]+)$/;

export function intLimitError(rows) {
  for (const [index, row] of (rows || []).entries()) {
    if (String(row?.["Data type"] || "").trim().toLowerCase() !== "int") continue;
    for (const bound of ["Lower Limit", "Upper Limit"]) {
      const raw = String(row?.[bound] ?? "").trim();
      if (!raw || raw.toUpperCase() === "NA") continue;
      if (!DECIMAL_LIMIT.test(raw) || !Number.isFinite(Number(raw))) {
        const name = String(row?.Parameter || "unnamed parameter").trim();
        return `Specification row ${index + 1} (${name}): ${bound} must be a finite decimal number or blank/NA for Int (for example 7.05 or -2.5).`;
      }
    }
  }
  return "";
}

export function vendorChangeError(source, selectedVendor, policy) {
  if (!source || source.vendor === selectedVendor || policy?.vendor_locked === false) return "";
  return policy?.reason || "Keep the existing vendor until lot history can be verified.";
}
